import { ScheduleType } from 'types/schedule'
import { UseStoreDeliveryBread } from 'hooks/storeDeliveryBread/useStoreDeliveryBread'
import { isValidNumber } from 'libphonenumber-js'
import { StoreDefaultScheduleType } from 'types/storeDefault'

export const isValidUrlString = (url: string): boolean => {
  if (url === '') return true
  const regexp = new RegExp('^https?://(?:[a-zA-Z]|[0-9]|[$-_]|[!*\\\\(\\\\),]|(?:%[0-9a-fA-F][0-9a-fA-F]))+')
  return regexp.test(url)
}

export const isNumerics = (text: string): boolean => {
  if (text === '') return true
  return /^\d*$/.test(text)
}

export const isValidPhoneNumber = (text: string): boolean => {
  if (text === '') return true
  return isValidNumber(text, 'JP')
}

export const isValidSchedules = (schedules: ScheduleType[], isScheduledGeneration?: boolean) => {
  return schedules.every((schedule) => {
    // 受け渡しオプションの空欄を許容しない
    if (schedule.choices.some((choice) => choice === '')) {
      return false
    }
    // 当日取り置きの自動配信、または事前予約の場合
    if (isScheduledGeneration) {
      // 曜日選択済み、受渡解禁時刻が指定されていてオープン時在庫数/販売上限数が1以上である
      return (
        schedule.days_of_week.length > 0 &&
        schedule.default_stocks.every((defaultStock) => defaultStock.pickupable_time !== '' && defaultStock.stock > 0)
      )
    } else {
      return true
    }
  })
}

export const isValidDefaultSchedules = (schedules: StoreDefaultScheduleType[], isScheduledGeneration?: boolean) => {
  return schedules.every((schedule) => {
    // 受け渡しオプションの空欄を許容しない
    if (schedule.choices.some((choice) => choice === '')) {
      return false
    }
    // 当日取り置きの自動配信、または事前予約の場合
    if (isScheduledGeneration) {
      // 曜日選択済み、受渡解禁時刻が指定されていてオープン時在庫数/販売上限数が1以上である
      return (
        schedule.days_of_week.length > 0 &&
        schedule.default_stocks.every((defaultStock) => defaultStock.pickupable_time !== '' && defaultStock.stock > 0)
      )
    } else {
      return true
    }
  })
}

export const isValidSharedSchedules = (schedules: ScheduleType[]) => {
  return schedules.every((schedule) => schedule.days_of_week.length > 0)
}

export const isValidStoreDeliveryBread = (storeDeliveryBreadForm: UseStoreDeliveryBread): boolean => {
  const { choices, deliveryCompany, maximumOrder, hoursToDeadline, isFrozenDelivery, frozenDeliveryType, packageSize } =
    storeDeliveryBreadForm

  return (
    choices.every((choice) => choice !== '') &&
    deliveryCompany !== '' &&
    maximumOrder >= 0 &&
    hoursToDeadline >= 0 &&
    (!isFrozenDelivery || (isFrozenDelivery && frozenDeliveryType !== '')) &&
    (packageSize === '60' || packageSize === '80' || packageSize === '100')
  )
}

export const isValidDomainSacri = (text: string): boolean => {
  if (text === '') return true
  // 設定してはいけない禁止ワード
  const forbiddenWords = ['www', 'ftp', 'smtp', 'pop', 'mail']
  // 先頭がハイフンでなく、半角英数字小文字およびハイフン
  const regex = /^(?!-)[a-z0-9-]{1,32}$/
  return regex.test(text) && !forbiddenWords.includes(text)
}
